import PropTypes from 'prop-types';
import React from 'react';

import Popup from "reactjs-popup";
import { toast } from 'react-toastify';

import PageSectionMenu from './PageSectionMenu';
import { SectionTitle } from './ClassicSectionCard';
import MarketingSummary from './MarketingSummary';
import OnepostComposer from '../../../bundles/OnepostComposer/components/OnepostComposer';

const modalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "430px",
  "padding": "15px"
}

const addSocialModalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "470px",
  "padding": "15px"
}

const composePostModalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "880px",
  "padding": "0px",
  "overflow": "hidden"
}

const canSubmitForm = (customerIOEmailPurpose, customerIOEmailTemplate) => {
  return (
    customerIOEmailPurpose
      && customerIOEmailPurpose.length > 0
      && customerIOEmailTemplate
      && customerIOEmailTemplate.length > 0
  );
}

const MarketingSection = ({
  csrfToken,
  team,
  confirm,
  currentUser,
  sendingCustomerIOEmail,
  sendingCustomerIOEmailChanged,
  customerIOEmailPurpose,
  customerIOEmailPurposeChanged,
  customerIOEmailTemplate,
  customerIOEmailTemplateChanged,
  createCustomerIOEmail,
  authorizedPages,
  addingNewSocialAccount,
  addingNewSocialAccountChanged,
  onepostPublicKey,
  twitterProviderId,
  facebookProviderId,
  composingPost,
  composingPostChanged,
  createPost,
  postToEdit,
  postToEditChanged,
  updatePost,
  confirmPageSection,
  fetchPermissionSet,
  updateConfirmPageSection,
  metaAdSpend,
  metaAdsConnected,
}) => (
  <div>
    <div className="card-body">
      <div className="row">
        <div className="col">
          <div className="row">
            <div className="col">
              <SectionTitle title="Marketing"
                            locked={Boolean(confirmPageSection.permission_set_id)} />
            </div>
            <div className="col-xs-auto position-absolute"
                 style={{
                   "paddingRight": "15px",
                   "right": "0px",
                   "top": "0px"
                 }}>
              <PageSectionMenu csrfToken={csrfToken}
                               team={team}
                               confirm={confirm}
                               currentUser={currentUser}
                               confirmPageSection={confirmPageSection}
                               fetchPermissionSet={fetchPermissionSet}
                               updateConfirmPageSection={updateConfirmPageSection} />
            </div>
          </div>
          <MarketingSummary teamId={team.id}
                            confirm={confirm}
                            metaAdSpend={metaAdSpend}
                            metaAdsConnected={metaAdsConnected} />

        </div>
      </div>
    </div>
    <Popup
      open={sendingCustomerIOEmail}
      contentStyle={modalContentStyle}
      closeOnDocumentClick={true}
      onClose={() => sendingCustomerIOEmailChanged(false)}
    >
      <div>
        <div className="row mb-5">
          <div className="col d-flex">
            <span className="d-flex justify-content-center align-self-center mr-3"
                  style={{
                    "display": "inline-block",
                    "width": "30px",
                    "height": "30px",
                    "borderRadius": "50%",
                    "color": "white",
                    "background": "#3c82bf"
                  }}>
              <i className="fas fa-envelope align-self-center"
                 style={{
                   "fontSize": "14px",
                   "marginTop": "2px"
                 }}>
              </i>
            </span>
            <h5 className="mb-0 align-self-center">
              <strong>Generate New Email</strong>
            </h5>
          </div>
          <div className="col-xs-auto" style={{"paddingRight": "15px"}}>
            <a href="#"
               style={{"fontSize": "24px"}}
               className="text-dark"
               onClick={(e) => {
                 e.preventDefault();
                 sendingCustomerIOEmailChanged(false);
               }} >
              <i className="fal fa-times"></i>
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <form onSubmit={
              (e) => {
                e.preventDefault();

                if(canSubmitForm(customerIOEmailPurpose, customerIOEmailTemplate)){
                  createCustomerIOEmail(confirm.eventbrite_event.eventbrite_id, customerIOEmailPurpose, customerIOEmailTemplate);
                }
              }
            }>
              <div className="form-group">
                <select className="form-control"
                        onChange={
                          (e) => {
                            customerIOEmailPurposeChanged(e.target.value);
                          }
                        }
                        value={customerIOEmailPurpose || ""}>
                  <option value="" disabled>Email purpose</option>
                  <option value="1">Show Announce</option>
                  <option value="2">Pre-Sale</option>
                  <option value="3">On-Sale</option>
                  <option value="4">Don’t Miss</option>
                </select>
              </div>
              <div className="form-group">
                <select className="form-control"
                        onChange={
                          (e) => {
                            customerIOEmailTemplateChanged(e.target.value);
                          }
                        }
                        value={customerIOEmailTemplate || ""}>
                  <option value="" disabled>Email template</option>
                  <option value="1">Design #1</option>
                  <option value="2">Design #2</option>
                </select>
              </div>
              <div className="form-row pt-3">
                <div className="col-12 text-right">
                  <a href="#" onClick={
                    (e) => {
                      e.preventDefault();
                      sendingCustomerIOEmailChanged(false);
                    }
                  }>
                    <strong>Cancel</strong>
                  </a>
                  <button type="submit"
                          disabled={!canSubmitForm(customerIOEmailPurpose, customerIOEmailTemplate)}
                          className="btn btn-primary ml-3">
                    <strong>Create</strong>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Popup>
    <Popup
      open={addingNewSocialAccount}
      contentStyle={addSocialModalContentStyle}
      closeOnDocumentClick={true}
      onClose={() => addingNewSocialAccountChanged(false)}
    >
      <div>
        <div className="row mb-5">
          <div className="col d-flex">
            <h5 className="mb-0 align-self-center">
              <strong>Add an account to Opendate</strong>
            </h5>
          </div>
          <div className="col-xs-auto" style={{"paddingRight": "15px"}}>
            <a href="#"
               style={{"fontSize": "24px"}}
               className="text-dark"
               onClick={(e) => {
                 e.preventDefault();
                 addingNewSocialAccountChanged(false);
               }} >
              <i className="fal fa-times"></i>
            </a>
          </div>
        </div>
        <div className="row mb-5">
          <div className="col d-none">
            <a className="text-dark" href={"https://api.getonepost.com/users/auth/twitter?provider_id=" + twitterProviderId + "&public_key=" + onepostPublicKey}>
              <div className="card mb-0 h-100">
                <div className="card-body text-center py-4 px-0">
                  <div style={{"height": "87px"}}>
                    <img className="img-fluid pb-2" src="/twitter@2x.png" style={{maxWidth: "64px"}} />
                  </div>
                  <strong className="d-block">Twitter</strong>
                </div>
              </div>
            </a>
          </div>
          <div className="col">
            <a className="text-dark" href={"https://api.getonepost.com/users/auth/facebook?provider_id=" + facebookProviderId + "&public_key=" + onepostPublicKey}>
              <div className="card mb-0 h-100">
                <div className="card-body text-center py-4 px-0">
                  <img className="img-fluid pb-2" src="/fb-insta@2x.png" style={{maxWidth: "113px"}} />
                  <strong className="d-block">Facebook & Instagram</strong>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Popup>
    <Popup
      open={composingPost}
      contentStyle={composePostModalContentStyle}
      closeOnDocumentClick={false}
      onClose={() => composingPostChanged(false)}
    >
      <div className="row">
        <div className="col-12">
          <div className="col-xs-auto position-absolute"
               style={{
                 "right": "37px",
                 "top": "26px"
               }}>
            <a href="#"
               style={{"fontSize": "24px"}}
               className="text-dark"
               onClick={(e) => {
                 e.preventDefault();
                 composingPostChanged(false);
               }} >
              <i className="fal fa-times"></i>
            </a>
          </div>
          <OnepostComposer publicKey={onepostPublicKey}
                           onSuccess={
                             (data) => {
                               createPost(csrfToken, team, confirm, data.token);
                             }
                           }
                           onFailure={
                             (error) => {
                               var messages = Object.keys(error).map((attribute) => (
                                 error[attribute].map((message) => (
                                   (attribute + " " + message)
                                 ))
                               )).flat().join(", ");

                               toast.error("An error occurred while processing your request (" + messages + ")", {
                                 position: toast.POSITION.TOP_CENTER,
                                 draggable: false,
                                 closeOnClick: false,
                                 autoClose: 5000,
                                 hideProgressBar: true
                               });
                             }
                           }
                           imageIds={[]}
                           authorizedPageIds={authorizedPages.map((ap) => ap.onepost_id)} />
        </div>
      </div>
    </Popup>
    <Popup
      open={Object.keys(postToEdit).length > 0}
      contentStyle={composePostModalContentStyle}
      closeOnDocumentClick={false}
      onClose={() => postToEditChanged({})}
    >
      <div className="row">
        <div className="col-12">
          <div className="col-xs-auto position-absolute"
               style={{
                 "right": "37px",
                 "top": "26px"
               }}>
            <a href="#"
               style={{"fontSize": "24px"}}
               className="text-dark"
               onClick={(e) => {
                 e.preventDefault();
                 postToEditChanged({});
               }} >
              <i className="fal fa-times"></i>
            </a>
          </div>
          <OnepostComposer publicKey={onepostPublicKey}
                           onSuccess={
                             (data) => {
                               updatePost(csrfToken, team, postToEdit, data.token);
                             }
                           }
                           onFailure={
                             (error) => {
                               toast.error("An error occurred while processing your request", {
                                 position: toast.POSITION.TOP_CENTER,
                                 draggable: false,
                                 closeOnClick: false,
                                 autoClose: 5000,
                                 hideProgressBar: true
                               });
                             }
                           }
                           token={postToEdit.onepost_token}
                           imageIds={[]}
                           authorizedPageIds={authorizedPages.map((ap) => ap.onepost_id)} />
        </div>
      </div>
    </Popup>
  </div>
);

MarketingSection.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  sendingCustomerIOEmail: PropTypes.bool.isRequired,
  sendingCustomerIOEmailChanged: PropTypes.func.isRequired,
  customerIOEmailPurpose: PropTypes.string,
  customerIOEmailPurposeChanged: PropTypes.func.isRequired,
  customerIOEmailTemplate: PropTypes.string,
  customerIOEmailTemplateChanged: PropTypes.func.isRequired,
  createCustomerIOEmail: PropTypes.func.isRequired,
  authorizedPages: PropTypes.array,
  addingNewSocialAccount: PropTypes.bool,
  addingNewSocialAccountChanged: PropTypes.func.isRequired,
  onepostPublicKey: PropTypes.string,
  twitterProviderId: PropTypes.number,
  facebookProviderId: PropTypes.number,
  composingPost: PropTypes.bool,
  composingPostChanged: PropTypes.func.isRequired,
  createPost: PropTypes.func.isRequired,
  postToEdit: PropTypes.object,
  postToEditChanged: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
  confirmPageSection: PropTypes.object,
  fetchPermissionSet: PropTypes.func.isRequired,
  updateConfirmPageSection: PropTypes.func.isRequired,
  metaAdSpend: PropTypes.array,
  metaAdsConnected: PropTypes.bool,
};

export default MarketingSection;
